import React from "react";
import Routes from "./Routes";
import WebSocketProvider from "./providers/WebSocketProvider";
import { ThemeProvider } from "./contexts/ThemeContext";
import { AntdThemeProvider } from "./components/AntdThemeProvider";

function App() {
  return (
    <ThemeProvider>
      <AntdThemeProvider>
        <WebSocketProvider>
          <Routes />
        </WebSocketProvider>
      </AntdThemeProvider>
    </ThemeProvider>
  );
}

export default App;
